var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCarbonFinance = function SvgIconCarbonFinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M27 11.5a1 1 0 0 0 1-1v-3a1 1 0 0 0-.66-.94l-11-4a1 1 0 0 0-.68 0l-11 4A1 1 0 0 0 4 7.5v3a1 1 0 0 0 1 1h1v13H4v2h24v-2h-2v-13zM6 8.2l10-3.64L26 8.2v1.3H6zm12 16.3h-4v-13h4zm-10-13h4v13H8zm16 13h-4v-13h4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M30 28.5H2v2h28z"
  })));
};
export default SvgIconCarbonFinance;